<template>
  <div ref="popover" @click="hidePopper" class="index-sider-overlay">
    <!-- 中央弹窗容器 -->
    <div
      :class="[
        {
          'zoom-in': popperShow,
          'zoom-out': !popperShow,
        },
        `${scope.clsPrefix}_modal`,
      ]"
      @click.stop
    >
      <div class="modal-head-container">
        <!-- 搜索框居中设计 -->
        <div class="modal-header">
          <div class="header-spacer"></div>
          <!-- 居中搜索框 -->
          <div class="search-container_center">
            <input
              type="text"
              v-model="searchKeyword"
              @input="handleSearch"
              @focus="handleSearchFocus"
              :placeholder="$t('app.searchApps')"
              class="search-input"
            />
            <i class="el-icon-search search-icon"></i>
            <!-- 搜索结果下拉框 -->
            <transition name="fade">
              <div
                v-show="searchKeyword && searchResults.length > 0"
                class="search-results"
              >
                <div class="search-results-title">
                  {{
                    $t('app.searchResultsCount', {
                      count: searchResults.length,
                    })
                  }}
                </div>
                <div class="search-results-list">
                  <div
                    v-for="result in searchResults"
                    :key="result.id"
                    class="search-result-item"
                    @click="clickApp(result)"
                  >
                    <div class="result-icon">
                      <img :src="result.icon || icAppManage" alt="应用图标" />
                    </div>
                    <div class="result-info">
                      <!-- 第一行：应用名称 + 常用按钮 分列两端 -->
                      <div class="result-row result-row-top">
                        <span class="result-name">{{ result.name }}</span>
                        <span
                          class="add-normal result-add"
                          @click.stop="addQuickApp(result.id)"
                        >
                          + {{ $t('app.addToQuickApps') }}
                        </span>
                      </div>
                      <!-- 第二行：领域/分类 + 负责人 分列两端 -->
                      <div class="result-row result-row-bottom">
                        <span class="result-domain-cat" v-if="result.domainName || result.categoryName">
                          <span v-if="result.domainName">{{ result.domainName }}</span>
                          <span v-if="result.domainName && result.categoryName" class="sep">/</span>
                          <span v-if="result.categoryName">{{ result.categoryName }}</span>
                        </span>
                        <span
                          class="result-owner"
                          v-if="result.ownerUserName"
                        >
                          {{ result.ownerUserName }}（{{
                            result.ownerUserCode
                          }}）
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="layout-toggle">
            <button
              class="toggle-btn"
              :class="{ active: layoutMode === 'list' }"
              @click="setLayoutMode('list')"
              title="列表布局"
            >
              <i class="el-icon-s-unfold"></i>
            </button>
            <button
              class="toggle-btn"
              :class="{ active: layoutMode === 'card' }"
              @click="setLayoutMode('card')"
              title="卡片布局"
            >
              <i class="el-icon-menu"></i>
            </button>
            </div>
        </div>
        <div class="category-container white-bg">
          <div class="category-header">
            <h4 class="category-title">
              {{ $t('app.frequentUse') }}
              <div class="right-desc">
                <i
                  class="el-icon-question"
                  style="margin-left: 8px"
                  @mouseover="showIcon('frequent-apps', 'showTooltip')"
                  @mouseleave="hideIcon('frequent-apps', 'showTooltip')"
                >
                  <transition name="dropdown">
                    <div
                      class="category-desc_dropdown"
                      v-show="showTooltip['frequent-apps']"
                      @click.stop
                    >
                      <div
                        class="category-desc_dropdown_container"
                        id="frequentAppsTooltip"
                      >
                        {{ $t('app.frequentAppsTooltip') }}
                      </div>
                    </div>
                  </transition>
                </i>
              </div>
            </h4>
          </div>
          <div
            v-if="normalAppList.length"
            class="frequent-apps"
            style="background-color: inherit; box-shadow: none"
          >
            <!-- 应用列表 -->
            <div class="app-list">
              <el-tooltip
                placement="top"
                v-for="app in normalAppList"
                :key="app.id"
              >
                <div slot="content">
                  {{ $t('common.owner') }}：{{ app.ownerUserName }}<br />{{
                    $t('common.employeeId')
                  }}：{{ app.ownerUserCode }}
                </div>
                <div
                  class="app-item"
                  @mouseenter="showIcon(app.id, 'appCancelShow')"
                  @mouseleave="hideIcon(app.id, 'appCancelShow')"
                  @click="clickApp(app)"
                >
                  <!-- :style="{background: !app.canAccess ? 'inherit' : '#f5f5f5'}" -->
                  <transition name="slide">
                    <div
                      v-show="appCancelShow[app.id]"
                      :key="app.id"
                      @click.stop="cancelQuickApp(app.id)"
                      class="el-icon-remove app-cancel"
                    ></div>
                  </transition>
                  <div class="app-icon">
                    <img
                      :style="{
                        filter: app.canAccess
                          ? 'grayscale(0%) brightness(1)'
                          : 'grayscale(70%) ',
                        opacity: app.canAccess ? 1 : 0.5,
                      }"
                      :src="app.icon || icAppManage"
                      alt="应用图标"
                    />
                    <span v-if="isNew(app)" class="new-badge">NEW</span>
                  </div>
                  <div
                    class="app-name-new single-line-ellipsis"
                    :title="app.name"
                    :style="{
                      color: app.canAccess === false ? '#333333!important' : '',
                    }"
                  >
                    {{ app.name }}
                  </div>
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="center-line"></div>
      <!-- 平铺展示内容区域 -->
      <div class="modal-content" v-loading="loading">
        <!-- 卡片布局 - 按领域分组 -->
        <div v-if="layoutMode === 'card'" class="domain-container">
          <div
            v-for="domain in domainList"
            :key="domain.domainId"
            class="domain-section"
          >
            <!-- 领域标题 -->
            <div class="domain-header">
              <h3 class="domain-title">
                <i class="el-icon-folder-opened"></i>
                {{ domain.domainName }}
                <span class="domain-count"
                  >（{{
                    $t('app.categoriesCount', {
                      count: domain.categories.length,
                    })
                  }}）</span
                >
              </h3>
            </div>

            <!-- 该领域下的分类卡片 -->
            <div class="category-cards-container">
              <div
                v-for="category in domain.categories"
                :key="category.appCategoryId"
                class="category-card"
                :class="{
                  expanded: expandedCards[category.appCategoryId],
                }"
                @mouseenter="handleCardMouseEnter(category)"
                @mouseleave="handleCardMouseLeave(category, $event)"
              >
                <!-- 卡片标题 -->
                <div class="card-header">
                  <h4 class="card-title">
                    {{ category.appCategoryName }}
                    <span class="app-count"
                      >（{{ category.appList.length }}）</span
                    >
                    <span
                      v-if="
                        canExpandCard(category) &&
                        !expandedCards[category.appCategoryId]
                      "
                      class="expand-toggle"
                      :class="{ active: expandedCards[category.appCategoryId] }"
                      @mouseenter.stop="handleExpandIconEnter(category)"
                    >
                      <i
                        :class="
                          expandedCards[category.appCategoryId]
                            ? 'el-icon-crop'
                            : 'el-icon-full-screen'
                        "
                        :title="
                          expandedCards[category.appCategoryId]
                            ? $t('common.collapse')
                            : $t('common.expand')
                        "
                      ></i>
                    </span>
                  </h4>
                </div>

                <!-- 卡片内容 -->
                <div class="card-content">
                  <!-- 左箭头 -->
                  <div
                    v-if="
                      canExpandCard(category) &&
                      expandedCards[category.appCategoryId] &&
                      getCurrentPage(category.appCategoryId) > 0
                    "
                    class="nav-arrow nav-arrow-left"
                    @click="prevPage(category.appCategoryId)"
                  >
                    <i class="el-icon-arrow-left"></i>
                  </div>

                  <!-- 右箭头 -->
                  <div
                    v-if="
                      canExpandCard(category) &&
                      expandedCards[category.appCategoryId] &&
                      getCurrentPage(category.appCategoryId) <
                        getTotalPages(category) - 1
                    "
                    class="nav-arrow nav-arrow-right"
                    @click="nextPage(category)"
                  >
                    <i class="el-icon-arrow-right"></i>
                  </div>

                  <div
                    class="app-grid"
                    :class="{
                      expanded: expandedCards[category.appCategoryId],
                      compact:
                        getDisplayApps(category).length <=
                        (expandedCards[category.appCategoryId]
                          ? 5
                          : 3),
                    }"
                    :data-category-id="category.appCategoryId"
                  >
                    <el-tooltip
                      placement="top"
                      v-for="app in getDisplayApps(category)"
                      :key="app.id"
                    >
                      <div slot="content">
                        负责人：{{ app.ownerUserName }}<br />工号：{{
                          app.ownerUserCode
                        }}
                      </div>
                      <div
                        class="app-item"
                        :class="{ 'search-highlight': highlightedAppId === app.id }"
                        :data-app-id="app.id"
                        @mouseenter="showIcon(app.id, 'appAddShow')"
                        @mouseleave="hideIcon(app.id, 'appAddShow')"
                        @click="clickApp(app)"
                      >
                        <transition
                          name="slide"
                          enter-active-class="custom-enter-active"
                          :css="false"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @after-enter="afterEnter"
                        >
                          <div
                            v-show="
                              appAddShow[app.id] && app.canAccess === true
                            "
                            :key="app.id"
                            class="app-add"
                            @click.stop="addQuickApp(app.id)"
                          >
                            <span style="font-size: 16px">+</span
                            >{{ $t('app.addToQuickApps') }}
                          </div>
                        </transition>
                        <transition
                          name="slide"
                          enter-active-class="custom-enter-active"
                          :css="false"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @after-enter="afterEnter"
                        >
                          <div
                            v-show="
                              appAddShow[app.id] && app.canAccess === false && accessApplyUrl
                            "
                            :key="app.id"
                            class="app-auth"
                          >
                            {{ $t('app.applyAccess') }}
                          </div>
                        </transition>

                        <div class="app-icon">
                          <img
                            :style="{
                              filter: app.canAccess
                                ? 'grayscale(0%) brightness(1)'
                                : 'grayscale(70%) ',
                              opacity: app.canAccess ? 1 : 0.5,
                            }"
                            :src="app.icon || icAppManage"
                            alt="应用图标"
                          />
                          <span v-if="isNew(app)" class="new-badge">NEW</span>
                        </div>
                        <div
                          class="app-name-new"
                          :class="[
                            expandedCards[category.appCategoryId]
                              ? 'single-line-ellipsis'
                              : '',
                            !(expandedCards[category.appCategoryId]) &&
                            app.name &&
                            app.name.length > 5
                              ? 'name-wrap'
                              : 'single-line-ellipsis',
                          ]"
                          :title="app.name"
                          :style="{
                            color:
                              app.canAccess === false
                                ? '#333333!important'
                                : '',
                          }"
                        >
                          {{ app.name }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 列表布局 - 按领域分组 -->
        <div v-if="layoutMode === 'list'" class="domain-list-container">
          <div
            v-for="domain in domainList"
            :key="domain.domainId"
            class="domain-section"
          >
            <!-- 领域标题 -->
            <div class="domain-header">
              <h3 class="domain-title">
                <i class="el-icon-folder-opened"></i>
                {{ domain.domainName }}
                <span class="domain-count"
                  >（{{
                    $t('app.categoriesCount', {
                      count: domain.categories.length,
                    })
                  }}）</span
                >
              </h3>
            </div>

            <!-- 该领域下的分类列表 -->
            <div class="category-list-container">
              <div
                v-for="category in domain.categories"
                :key="category.appCategoryId"
                class="category-container"
              >
                <div class="app-category">
                  <!-- 分类标题（移入应用区域内部，仅列表模式） -->
                  <div class="category-header in-app">
                    <h4 class="category-title">
                      {{ category.appCategoryName }}（{{
                        category.appList.length
                      }}）
                      <div class="right-desc">
                        <i
                          v-if="category.appCategoryDesc"
                          class="el-icon-question"
                          @mouseover="
                            showIcon(category.appCategoryId, 'showTooltip')
                          "
                          @mouseleave="
                            hideIcon(category.appCategoryId, 'showTooltip')
                          "
                        >
                          <transition name="dropdown">
                            <div
                              class="category-desc_dropdown"
                              v-show="showTooltip[category.appCategoryId]"
                              @click.stop
                            >
                              <div
                                class="category-desc_dropdown_container"
                                id="categoryDescDropdown"
                                ref="categoryDescPopover"
                              >
                                {{ category.appCategoryDesc }}
                              </div>
                            </div>
                          </transition>
                        </i>
                      </div>
                    </h4>
                  </div>
                  <!-- 应用列表 -->
                  <div class="app-list">
                    <el-tooltip
                      placement="top"
                      v-for="app in category.appList"
                      :key="app.id"
                    >
                      <div slot="content">
                        负责人：{{ app.ownerUserName }}<br />工号：{{
                          app.ownerUserCode
                        }}
                      </div>
                      <div
                        class="app-item"
                        :class="{ 'search-highlight': highlightedAppId === app.id }"
                        :data-app-id="app.id"
                        @mouseenter="showIcon(app.id, 'appAddShow')"
                        @mouseleave="hideIcon(app.id, 'appAddShow')"
                        @click="clickApp(app)"
                      >
                        <transition
                          name="slide"
                          enter-active-class="custom-enter-active"
                          :css="false"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @after-enter="afterEnter"
                        >
                          <div
                            v-show="
                              appAddShow[app.id] && app.canAccess === true
                            "
                            :key="app.id"
                            class="app-add"
                            @click.stop="addQuickApp(app.id)"
                          >
                            <span style="font-size: 16px">+</span
                            >{{ $t('app.addToQuickApps') }}
                          </div>
                        </transition>
                        <transition
                          name="slide"
                          enter-active-class="custom-enter-active"
                          :css="false"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @after-enter="afterEnter"
                        >
                          <div
                            v-show="
                              appAddShow[app.id] && app.canAccess === false && accessApplyUrl
                            "
                            :key="app.id"
                            class="app-auth"
                          >
                            {{ $t('app.applyAccess') }}
                          </div>
                        </transition>

                        <div class="app-icon">
                          <img
                            :style="{
                              filter: app.canAccess
                                ? 'grayscale(0%) brightness(1)'
                                : 'grayscale(70%) ',
                              opacity: app.canAccess ? 1 : 0.5,
                            }"
                            :src="app.icon || icAppManage"
                            alt="应用图标"
                          />
                          <span v-if="isNew(app)" class="new-badge">NEW</span>
                        </div>
                        <div
                          class="app-name-new single-line-ellipsis"
                          :title="app.name"
                          :style="{
                            color:
                              app.canAccess === false
                                ? '#333333!important'
                                : '',
                          }"
                        >
                          {{ app.name }}
                        </div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 请求应用分类
import {
  incrementQuickApps,
  requestAppGroupsByDomain,
  requestQuickApps,
  setQuickApps,
  cancelQuickApps,
  requestAppDomainTypeList
  // getAppApplyUrl,
} from '@/api/app.js'
import icAppManage from '@/assets/ic_app_manage.png'
import microApp from '@micro-zoe/micro-app'
import { mapActions } from 'vuex'
import { removeDomScope } from '@micro-zoe/micro-app'
export default {
  // 组件名称
  name: 'IndexHeaderApps',
  computed: {
    dataList() {
      const weightComparator = (a, b) => Number(b.weight) - Number(a.weight)
      const sourceData = this.$store.state.app.dataList || []
      return sourceData
        .map((item) => ({
          ...item,
          appList: (item.appList || [])
            .slice() // 避免修改原始数组
            .filter((app) => app.context !== 'process') // ⬅️ 新增：去除 context === 'process' 的项
            .sort(weightComparator)
        }))
        .slice() // 避免修改原始数组
        .sort(weightComparator)
        .filter((item) => item.appList.length > 0)
    },
    domainList() {
      const weightComparator = (a, b) => Number(b.weight) - Number(a.weight)
      const sourceData = this.$store.state.app.domainData || []
      return sourceData
        .map((domain) => ({
          ...domain,
          categories: (domain.categories || [])
            .map((category) => ({
              ...category,
              appList: (category.appList || [])
                .slice()
                .filter((app) => app.context !== 'process')
                .sort(weightComparator)
            }))
            .filter((category) => category.appList.length > 0)
            .sort(weightComparator)
        }))
        .filter((domain) => domain.categories.length > 0)
        .sort(weightComparator)
    },
    normalAppList() {
      return this.$store.state.app.normalAppList
    },
    popperShow() {
      return this.$store.state.app.popperShow
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'index-sider'
      },
      accessApplyUrl: sessionStorage.getItem('accessApplyUrl'),
      icAppManage: icAppManage,
      appAddShow: {},
      appCancelShow: {},
      showTooltip: {},
      // 搜索关键词
      searchKeyword: '',
      // 搜索结果
      searchResults: [],
      // 搜索高亮的应用 id
      highlightedAppId: null,
      // 卡片展开状态
      expandedCards: {},
      // 搜索程序化展开锁定的卡片 categoryId 集合（hover 移出不收起）
      searchExpandedCards: {},
      // 分页状态
      cardPages: {},
      // 收起防抖计时器
      collapseTimers: {},
      expandTimers: {},
      // 布局模式：card 或 list
      layoutMode: 'list', // 默认使用列表布局，便于直接观察交互
      // 视角参数绑定（不展示 UI，仅用于请求）
      selectedDomainType: '',
      domainTypeByMode: { list: '', card: '' },
      loading: false
    }
  },
  // 创建完成
  created() {
    removeDomScope(true) // 解除元素绑定
    // 搜索滚动防打断：非响应式属性（不用 data，避免 vue/no-reserved-keys）
    this._scrollTimers = []
    this._scrollToken = 0
    // 从 localStorage 读取布局模式
    const savedLayoutMode = localStorage.getItem('appLayoutMode')
    if (savedLayoutMode && ['card', 'list'].includes(savedLayoutMode)) {
      this.layoutMode = savedLayoutMode
    }
    // 初始化方法
    // this.init()
    // 加载视角字典并建立按钮->domainType 映射
    this.loadDomainTypes()
  },
  // 挂载完成
  mounted() {
    // 绑定事件
    this.bindEvent()
    this.accessApplyUrl = sessionStorage.getItem('accessApplyUrl')
  },
  // 销毁之前
  beforeDestroy() {
    // 解除事件绑定
    this.unbindEvent()
    // 清理所有收起防抖计时器
    if (this.collapseTimers) {
      Object.keys(this.collapseTimers).forEach((key) => {
        const t = this.collapseTimers[key]
        if (t) clearTimeout(t)
      })
    }
    if (this.expandTimers) {
      Object.keys(this.expandTimers).forEach((key) => {
        const t = this.expandTimers[key]
        if (t) clearTimeout(t)
      })
    }
  },
  // 方法
  methods: {
    ...mapActions('app', ['setNormalAppList']),
    // 判断应用是否为15天内创建，用于显示 NEW 角标
    isNew(app) {
      if (!app || typeof app !== 'object') return false
      // 兼容多种可能的创建时间字段
      const keys = [
        'createTime',
        'gmtCreate',
        'createdAt',
        'create_date',
        'createDate',
        'publishTime',
        'onlineTime',
        'releaseTime'
      ]
      let val = null
      for (const k of keys) {
        if (app[k]) {
          val = app[k]
          break
        }
      }
      if (!val) return false

      let ts = null
      if (typeof val === 'number') {
        // 可能是秒或毫秒
        ts = val > 1e12 ? val : val * 1000
      } else if (typeof val === 'string') {
        const num = Number(val)
        if (!Number.isNaN(num) && val.trim() !== '') {
          ts = num > 1e12 ? num : num * 1000
        } else {
          const parsed = Date.parse(val)
          if (!Number.isNaN(parsed)) ts = parsed
        }
      } else if (val instanceof Date) {
        ts = val.getTime()
      }

      if (!ts || Number.isNaN(ts)) return false
      const now = Date.now()
      const FIFTEEN_DAYS = 15 * 24 * 60 * 60 * 1000
      return now - ts <= FIFTEEN_DAYS && ts <= now
    },
    // 进入动画钩子函数
    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(20px)'
    },
    enter(el, done) {
      // 设置过渡时间
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease'

      // 在下一帧应用动画效果
      this.$nextTick(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'

        // 动画结束后调用 done 回调
        setTimeout(done, 500)
      })
    },
    afterEnter(el) {
      // 重置样式
      el.style.transition = ''
    },
    goNoAuth(app) {
      this.$router.push({
        path: '/permission',
        query: {
          appName: app.name
        }
      })
      this.$store.commit('app/SET_POPPER_SHOW', false)
    },
    addQuickApp(id) {
      setQuickApps(id).then((res) => {
        this.getData()
      })
    },
    cancelQuickApp(id) {
      cancelQuickApps(id).then((res) => {
        this.getData()
      })
    },
    /**
     * 点击跳转到子应用
     * @param {Object} appItem 应用信息项
     * @returns {void}
     */
    clickApp(appItem) {
      if (appItem.context === this.$route.meta.context) {
        this.hidePopper()
        return
      }
      appItem.canAccess &&
        incrementQuickApps(appItem.id).then((res) => {
          console.log(`访问${appItem.name}`)
        })
      // const res = await getAppApplyUrl({ appId: appItem.id })
      // const accessApplyUrl = res.data
      // sessionStorage.setItem('accessApplyUrl', accessApplyUrl)
      if (appItem.canAccess) {
        if (appItem.enterNeedFresh == '1') {
          microApp.unmountAllApps().then(() => {
            window.open(
              window.location.origin + '/' + appItem.context + '/',
              '_self'
            )
          })
        } else if (appItem.type == 'HREF') {
          window.open(appItem.url, '_blank')
        } else if (appItem.type == 'INNER_APP' && this.$route.path == '/') {
          window.open(
            window.location.origin + '/' + appItem.context + '/',
            '_self'
          )
        } else {
          microApp.unmountAllApps().then(() => {
            this.$router.push(`/${appItem.context}/`)
          })
        }
      } else {
        // window.location.href = '/noPermission'
        // localStorage.setItem("beforeApp", appItem.name);
        this.$router.push(
          `/noPermission?appName=${appItem.name}&appId=${appItem.id}`
        )
      }
      this.$store.commit('app/SET_POPPER_SHOW', false)
    },

    /**
     * 初始化方法
     * @returns {void}
     */
    // init() {
    //   // 获取数据
    //   this.getData()
    // },

    /**
     * 获取数据
     * @returns {void}
     */
    async getData() {
      this.loading = true
      // 请求权限菜单
      const menuList = await this.$store.dispatch('user/getUserMenus')
      // 组装权限路由
      await this.$store.dispatch('permission/generateRoutes', menuList)
      try {
        // 并行请求应用分类列表和常用应用列表
        // 携带 domainType 参数（若存在）
        const params = {}
        if (
          this.selectedDomainType !== '' &&
          this.selectedDomainType !== null &&
          this.selectedDomainType !== undefined
        ) {
          params.domainType = this.selectedDomainType
        }
        // 添加 industryLabelId 参数（只使用当前登录企业的）
        if (this.$store.state.user.currentTenant?.industryLabelId) {
          params.industryLabelId = this.$store.state.user.currentTenant.industryLabelId
        }
        const [appGroupsResponse, quickAppsResponse] = await Promise.all([
          requestAppGroupsByDomain(params),
          requestQuickApps(10)
        ])

        const appGroupsData = appGroupsResponse.data
        const quickAppsData = quickAppsResponse.data

        // 保持原始的三层结构(领域->分类->应用)，不再扁平化
        const domainData = this.processDomainData(appGroupsData)
        // 更新组件数据和 sessionStorage
        sessionStorage.setItem('domainData', JSON.stringify(domainData))
        this.$store.commit('app/SET_DOAMIN_DATA', domainData)
        // 为了兼容性，同时生成扁平化数据用于搜索等功能
        const flattenedData = this.flattenDomainData(appGroupsData)
        const appList = []
        const dataList = [
          {
            appList: []
          }
        ]
        flattenedData.forEach((element) => {
          if (element.appList && element.appList.length > 0) {
            appList.push(
              ...element.appList.map((app) => ({
                apiUrl: app.apiUrl,
                url: app.url,
                context: app.context,
                owner: app.ownerUserCode,
                isOwner:
                  app.ownerUserCode ===
                  this.$store.state.user.userInfo.userCode
              }))
            )
            dataList[0].appList.push(...element.appList)
          }
        })
        sessionStorage.setItem('appList', JSON.stringify(appList))
        this.$store.commit('app/SET_DATA_LIST', dataList)
        sessionStorage.setItem('dataList', JSON.stringify(dataList))
        this.loading = false
        // 设置常用应用列表
        if (quickAppsData) {
          this.$store.commit('app/SET_NORMAL_APPLIST', quickAppsData)
        }
      } catch (error) {
        this.loading = false
        console.error('获取数据时出错:', error)
        // 可以在这里添加更多的错误处理逻辑，例如显示错误提示给用户
      }
    },

    /**
     * 绑定事件
     * @returns {void}
     */
    bindEvent() {
      document.addEventListener('click', this.handleClickOutside, true)
    },

    /**
     * 解除事件绑定
     * @returns {void}
     */
    unbindEvent() {
      document.removeEventListener('click', this.handleClickOutside, true)
    },

    /**
     * 切换弹层显示状态
     * @returns {void}
     */
    togglePopper() {
      this.$store.commit(
        'app/SET_POPPER_SHOW',
        !this.$store.state.app.popperShow
      )
    },

    /**
     * 隐藏弹层
     * @returns {void}
     */
    hidePopper() {
      this.$store.commit('app/SET_POPPER_SHOW', false)
    },

    /**
     * 显示
     * @returns {void}
     */
    show() {
      this.$emit('show')
    },

    /**
     * 隐藏
     * @returns {void}
     */
    hide() {
      this.$emit('hide')
    },

    /**
     * 显示添加应用按钮
     * @returns {void}
     */
    showIcon(id, data) {
      this.$set(this[data], id, true)
    },
    /**
     * 隐藏添加应用按钮
     * @returns {void}
     */
    hideIcon(id, data) {
      this.$set(this[data], id, false)
    },
    /**
     * 处理搜索输入
     * @returns {void}
     */
    handleSearch() {
      // 搜索逻辑实现
      if (!this.searchKeyword.trim()) {
        this.searchResults = []
        this.clearSearchHighlight()
        return
      }

      const keyword = this.searchKeyword.toLowerCase().trim()
      const results = []

      // 搜索所有分类中的应用
      if (this.domainList && this.domainList.length) {
        this.domainList.forEach((domains) => {
          if (domains.appCategories && domains.appCategories.length) {
            domains.appCategories.forEach((category) => {
              if (category.appList && category.appList.length) {
                const matches = category.appList.filter((app) =>
                  app.name.toLowerCase().includes(keyword)
                )
                // 添加领域 + 分类信息
                const categoryMatches = matches.map((app) => ({
                  ...app,
                  domainName: domains.domainName || '',
                  domainId: domains.domainId || '',
                  categoryName: category.appCategoryName,
                  categoryId: category.appCategoryId
                }))
                results.push(...categoryMatches)
              }
            })
          }
        })
      }
      // 限制最多显示10条结果
      this.searchResults = results.slice(0, 10)

      // 自动滚动到第一个匹配应用并高亮
      if (this.searchResults.length > 0) {
        this.scrollToAndHighlight(this.searchResults[0])
      } else {
        this.clearSearchHighlight()
      }
    },

    /**
     * 清除搜索高亮 + 弹框内容区滚回顶部
     */
    clearSearchHighlight() {
      this.highlightedAppId = null
      // 收起所有被搜索触发展开的卡片
      if (this.expandedCards) {
        Object.keys(this.expandedCards).forEach((key) => {
          this.$set(this.expandedCards, key, false)
        })
      }
      // 清除搜索程序化展开的锁定标记，恢复正常 hover 行为
      if (this.searchExpandedCards) {
        Object.keys(this.searchExpandedCards).forEach((key) => {
          this.$set(this.searchExpandedCards, key, false)
        })
      }
      const content = document.querySelector('.modal-content')
      // 瞬时回顶（auto），避免 smooth 长动画与后续可能的 scrollToAndHighlight 冲突导致滚动失效
      if (content) content.scrollTo({ top: 0, behavior: 'auto' })
    },

    /**
     * 滚动弹框内容到指定应用，自动处理卡片布局的展开 + 翻页
     * @param {Object} matchApp 匹配到的应用对象（含 id, categoryId 等）
     */
    scrollToAndHighlight(matchApp) {
      // 取消上一轮还未执行的 scroll 定时器，避免快速连续输入时互相打断
      if (this._scrollTimers && this._scrollTimers.length) {
        this._scrollTimers.forEach((t) => clearTimeout(t))
      }
      this._scrollTimers = []
      // 立即打断可能正在进行的原生 smooth 滚动（如 clearSearchHighlight 的回顶动画或上一轮 scrollIntoView），
      // 避免与新 scroll 冲突导致滚动失效
      const _container = document.querySelector('.modal-content')
      if (_container) _container.scrollTo({ top: _container.scrollTop, behavior: 'auto' })
      // token 自增：旧闭包执行时会发现 token 不匹配而跳过
      const token = (this._scrollToken = (this._scrollToken || 0) + 1)

      const appId = matchApp.id || matchApp.appId
      const categoryId = matchApp.categoryId || matchApp.appCategoryId

      if (!appId) return

      // 先设置高亮 id（Vue 渲染 search-highlight class）
      this.highlightedAppId = appId

      let needExpand = false

      if (this.layoutMode === 'card') {
        // 卡片布局：需要找到 category 并展开 + 翻页
        const targetCategory = this._findCategoryById(categoryId)
        if (targetCategory) {
          // 1. 搜索模式下始终展开目标卡片（无论应用多寡，都要有放大效果）
          needExpand = !this.expandedCards[categoryId]
          // 2. 找到 app 在 appList 中的 index，算出正确页码
          const appIndex = targetCategory.appList.findIndex((a) => a.id === appId)
          if (appIndex >= 0) {
            const isExpanded = needExpand || this.expandedCards[categoryId]
            const appsPerPage = isExpanded ? 25 : 9
            const targetPage = Math.floor(appIndex / appsPerPage)

            if (needExpand) {
              // 先展开（展开会把 cardPages[categoryId] reset 为 0，再手动设为目标页）
              this.$set(this.expandedCards, categoryId, true)
              // 标记为搜索程序化展开，hover 移出不收起
              this.$set(this.searchExpandedCards, categoryId, true)
              // 关闭其他卡片（复用 toggleCardExpand 的行为）
              Object.keys(this.expandedCards).forEach((key) => {
                if (key !== String(categoryId)) {
                  this.$set(this.expandedCards, key, false)
                  this.$set(this.searchExpandedCards, key, false)
                }
              })
            }
            // 设置正确的页码（确保目标应用 DOM 存在）
            this.$set(this.cardPages, categoryId, targetPage)
          }
        }
      }
      // 列表布局所有 app 都直接渲染了，不需要展开/翻页

      // 等 DOM + CSS 动画都稳定后再 scroll
      const doScroll = () => {
        const el = document.querySelector(`.modal-content [data-app-id="${appId}"]`)
        const container = document.querySelector('.modal-content')
        if (!el || !container) return

        // 第一步：让 app-item 居中
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })

        // 第二步：等 smooth 滚动结束后，微调让领域标题也露出
        const t = setTimeout(() => {
          // token 校验：如果已被新一轮 scroll 取消则跳过
          if (this._scrollToken !== token) return
          const domainSection = el.closest('.domain-section')
          if (!domainSection) return
          const domainHeader = domainSection.querySelector('.domain-header')
          if (!domainHeader) return

          const containerRect = container.getBoundingClientRect()
          const headerRect = domainHeader.getBoundingClientRect()
          const appRect = el.getBoundingClientRect()

          // 领域标题被裁剪在视口上方 → 需要往上滚
          if (headerRect.top < containerRect.top) {
            let offset = containerRect.top - headerRect.top + 10 // +10px 留白
            // 检查往上滚后 app-item 底部是否仍在视口内
            const newAppBottom = appRect.bottom + offset
            if (newAppBottom > containerRect.bottom) {
              // 领域 + app 总高超出视口，优先保 app 底部可见，减少上滚量
              offset = Math.max(0, containerRect.bottom - appRect.bottom - 10)
            }
            if (offset > 0) {
              container.scrollBy({ top: -offset, behavior: 'smooth' })
            }
          }
        }, 500) // 等 scrollIntoView smooth 完成
        this._scrollTimers.push(t)
      }
      if (needExpand) {
        // 卡片展开有 CSS transition，延迟等动画结束再定位
        const t = setTimeout(doScroll, 300)
        this._scrollTimers.push(t)
      } else {
        this.$nextTick(doScroll)
      }
    },

    /**
     * 根据 categoryId 在 domainList 里找到对应的 category 对象
     * @param {string|number} categoryId
     * @returns {Object|null}
     */
    _findCategoryById(categoryId) {
      if (!this.domainList) return null
      for (const domain of this.domainList) {
        if (domain.appCategories) {
          const found = domain.appCategories.find(
            (c) => String(c.appCategoryId) === String(categoryId)
          )
          if (found) return found
        }
        // 兼容 processDomainData 结构（categories 字段）
        if (domain.categories) {
          const found = domain.categories.find(
            (c) => String(c.appCategoryId) === String(categoryId)
          )
          if (found) return found
        }
      }
      return null
    },

    /**
     * 处理搜索框聚焦事件
     * 搜索框有内容且有匹配结果时，重新滚动定位并展开容器
     * （修复：搜索展开后点击/悬停其他卡片导致搜索结果对应卡片被收起，
     *  再次点击搜索框时无法自动滚回的问题）
     */
    handleSearchFocus() {
      if (this.searchKeyword && this.searchResults && this.searchResults.length > 0) {
        this.scrollToAndHighlight(this.searchResults[0])
      }
    },

    /**
     * 处理搜索框失焦事件
     */
    handleSearchBlur() {
      // 延迟隐藏搜索结果，以便用户可以点击结果
      setTimeout(() => {
        this.searchKeyword = ''
        this.searchResults = []
      }, 200)
    },

    /**
     * 清空搜索框
     */
    clearSearch() {
      this.searchKeyword = ''
      this.searchResults = []
    },

    /**
     * 点击搜索结果项
     */
    handleResultClick(result) {
      this.clickApp(result)
      this.clearSearch()
    },
    /**
     * 处理点击外部区域
     * @param {Event} event 事件对象
     * @returns {void}
     */
    handleClickOutside(event) {
      if (!this.popperShow) {
        return
      }

      const pop = this.$refs.popover
      if (!pop) {
        return
      }

      // 点击弹层外：关闭整体弹层
      if (!pop.contains(event.target)) {
        this.hidePopper()
        return
      }

      // 点击弹层内：若有展开的卡片，且点击不在任何展开卡片内，则收起所有卡片
      const expandedCards = this.expandedCards || {}
      const hasExpanded = Object.keys(expandedCards).some(function (key) {
        return !!expandedCards[key]
      })
      if (!hasExpanded) {
        return
      }

      const expandedEls = this.$el.querySelectorAll('.category-card.expanded')
      var insideAnyExpanded = false
      expandedEls.forEach(function (el) {
        if (el.contains(event.target)) {
          insideAnyExpanded = true
        }
      })

      if (!insideAnyExpanded) {
        Object.keys(expandedCards).forEach((key) => {
          if (expandedCards[key]) {
            this.$set(this.expandedCards, key, false)
          }
        })
      }
    },

    /**
     * 展开卡片
     * @param {string} categoryId 分类ID
     */
    expandCard(categoryId) {
      // 如果存在收起计时器，先清除，避免快速进出导致抖动
      const timer = this.collapseTimers[categoryId]
      if (timer) {
        clearTimeout(timer)
        this.collapseTimers[categoryId] = null
      }
      Object.keys(this.expandedCards).forEach((key) => {
        if (key !== String(categoryId)) {
          this.$set(this.expandedCards, key, false)
          // 同步清除其搜索锁定标记，避免被收起的卡片锁定标记残留
          this.$set(this.searchExpandedCards, key, false)
        }
      })
      this.$set(this.expandedCards, categoryId, true)
      this.$set(this.cardPages, categoryId, 0)
    },

    /**
     * 收起卡片
     * @param {string} categoryId 分类ID
     */
    collapseCard(categoryId) {
      // 延迟收起，给用户微小的移动容错空间，减少边缘抖动
      const existing = this.collapseTimers[categoryId]
      if (existing) clearTimeout(existing)
      this.collapseTimers[categoryId] = setTimeout(() => {
        this.$set(this.expandedCards, categoryId, false)
        this.collapseTimers[categoryId] = null
      }, 220)
    },

    /**
     * 加载视角字典并建立按钮->domainType 映射
     * 不展示 UI，仅用于请求参数
     */
    loadDomainTypes() {
      requestAppDomainTypeList()
        .then((res) => {
          const list = Array.isArray(res?.data) ? res.data : res || []
          // 解析常见键
          const normalize = (o) => ({
            label:
              o.description ||
              o.desc ||
              o.label ||
              o.name ||
              o.text ||
              o.title ||
              `${o.code || o.value || o.id}`,
            value: o.value || o.code || o.id
          })
          const options = list.map(normalize)
          // 基于名称包含来匹配
          const user =
            options.find((i) => /用户/.test(String(i.label))) || options[0]
          const arch =
            options.find((i) => /架构/.test(String(i.label))) ||
            options[1] ||
            options[0]
          this.domainTypeByMode = {
            list: user ? user.value : '',
            card: arch ? arch.value : ''
          }
          // 根据当前布局设置 selectedDomainType
          this.selectedDomainType = this.resolveDomainTypeByMode(
            this.layoutMode
          )
          // 初始加载后刷新数据
          this.getData()
        })
        .catch(() => {
          // 字典失败则不带参数查询
          this.domainTypeByMode = { list: '', card: '' }
        })
    },

    /**
     * 根据布局模式取对应 domainType
     */
    resolveDomainTypeByMode(mode) {
      return (this.domainTypeByMode && this.domainTypeByMode[mode]) || ''
    },

    /**
     * 获取当前页码
     * @param {string} categoryId 分类ID
     * @returns {number}
     */
    getCurrentPage(categoryId) {
      return this.cardPages[categoryId] || 0
    },

    /**
     * 获取总页数
     * @param {Object} category 分类对象
     * @returns {number}
     */
    getTotalPages(category) {
      const appsPerPage = this.expandedCards[category.appCategoryId] ? category.appList.length : 9
      return Math.ceil(category.appList.length / appsPerPage)
    },

    /**
     * 获取当前页显示的应用
     * @param {Object} category 分类对象
     * @returns {Array}
     */
    getDisplayApps(category) {
      const currentPage = this.getCurrentPage(category.appCategoryId)
      const isExpanded = this.expandedCards[category.appCategoryId]
      const appsPerPage = isExpanded ? 25 : 9 // 收起时显示9个应用(3×3)，展开时显示25个应用(5×5)
      const startIndex = currentPage * appsPerPage
      const endIndex = startIndex + appsPerPage
      return category.appList.slice(startIndex, endIndex)
    },

    /**
     * 上一页
     * @param {string} categoryId 分类ID
     */
    prevPage(categoryId) {
      const currentPage = this.getCurrentPage(categoryId)
      if (currentPage > 0) {
        this.animatePageTransition(categoryId, 'prev')
        setTimeout(() => {
          this.$set(this.cardPages, categoryId, currentPage - 1)
        }, 150)
      }
    },

    /**
     * 下一页
     * @param {string} categoryId 分类ID
     */
    nextPage(category) {
      // 兼容对象或直接传入ID
      const catId =
        (category &&
          (category.appCategoryId || category.categoryId || category.id)) ||
        category
      const currentPage = this.getCurrentPage(catId)
      const totalPages = this.getTotalPages(category)
      if (currentPage < totalPages - 1) {
        this.animatePageTransition(catId, 'next')
        setTimeout(() => {
          this.$set(this.cardPages, catId, currentPage + 1)
        }, 150)
      }
    },

    /**
     * 翻页动画效果
     * @param {string} categoryId 分类ID
     * @param {string} direction 方向：prev 或 next
     */
    animatePageTransition(categoryId, direction) {
      const appGrid = document.querySelector(
        `.app-grid[data-category-id="${categoryId}"]`
      )
      if (appGrid) {
        const translateX = direction === 'next' ? '-20px' : '20px'
        appGrid.style.transform = `translateX(${translateX})`
        appGrid.style.opacity = '0.7'

        setTimeout(() => {
          appGrid.style.transform = 'translateX(0)'
          appGrid.style.opacity = '1'
        }, 150)
      }
    },

    /**
     * 设置布局模式
     * @param {string} mode 布局模式：card 或 list
     */
    setLayoutMode(mode) {
      this.layoutMode = mode
      // 同步设置 domainType 并重新加载
      this.selectedDomainType = this.resolveDomainTypeByMode(mode)
      this.getData().then(() => {
        // 切换布局后，API 数据结构可能变了，先重新跑一次搜索刷新结果 + scroll + highlight
        if (this.searchKeyword.trim()) {
          this.handleSearch()
        }
      })
      // 可以将用户的选择保存到localStorage
      localStorage.setItem('appLayoutMode', mode)
    },

    /**
     * 截取应用名称，最多显示5个字
     * @param {string} name 应用名称
     * @returns {string}
     */
    truncateAppName(name) {
      if (!name) return ''
      return name.length > 6 ? name.substring(0, 6) + '...' : name
    },

    /**
     * 切换卡片展开/收起
     * @param {Object|string} category 分类对象或分类ID
     */
    toggleCard(category) {
      const categoryId =
        category && typeof category === 'object'
          ? category.appCategoryId
          : category

      if (!categoryId) return

      // 仅当应用数量 > 6 时允许展开
      const canExpand =
        category && typeof category === 'object'
          ? this.canExpandCard(category)
          : true
      if (!canExpand) {
        this.$set(this.expandedCards, categoryId, false)
        this.$set(this.cardPages, categoryId, 0)
        return
      }

      const next = !this.expandedCards[categoryId]
      // 用户手动操作，清除该卡片的搜索锁定标记（用户意图优先，恢复正常 hover 行为）
      this.$set(this.searchExpandedCards, categoryId, false)
      if (next) {
        // 仅保留当前展开，其它全部收起
        Object.keys(this.expandedCards).forEach((key) => {
          if (key !== String(categoryId)) {
            this.$set(this.expandedCards, key, false)
            // 同步清除其搜索锁定标记，避免状态不一致
            this.$set(this.searchExpandedCards, key, false)
          }
        })
      }
      this.$set(this.expandedCards, categoryId, next)
      if (next) {
        // 展开时重置到第1页
        this.$set(this.cardPages, categoryId, 0)
      }
    },

    canExpandCard(category) {
      return (
        (category && category.appList && category.appList.length > 6) || false
      )
    },

    handleCardMouseEnter(category) {
      if (!this.canExpandCard(category)) return
      const categoryId = category.appCategoryId
      const timer = this.collapseTimers[categoryId]
      if (timer) {
        clearTimeout(timer)
        this.collapseTimers[categoryId] = null
      }
    },

    handleExpandIconEnter(category) {
      if (!this.canExpandCard(category)) return
      const categoryId = category.appCategoryId
      const existing = this.expandTimers[categoryId]
      if (existing) clearTimeout(existing)

      const timer = this.collapseTimers[categoryId]
      if (timer) {
        clearTimeout(timer)
        this.collapseTimers[categoryId] = null
      }

      this.expandTimers[categoryId] = setTimeout(() => {
        this.expandCard(categoryId)
        // hover 展开接管，清除该卡片的搜索锁定标记（恢复正常 hover 行为）
        this.$set(this.searchExpandedCards, categoryId, false)
        this.expandTimers[categoryId] = null
      }, 260)
    },

    handleCardMouseLeave(category, event) {
      if (!this.canExpandCard(category)) return
      // 如果鼠标移到了 tooltip 浮层上，不收起卡片
      if (event && event.relatedTarget) {
        const el = event.relatedTarget
        if (el.classList && (el.classList.contains('el-tooltip__popper') || el.closest('.el-tooltip__popper'))) {
          return
        }
      }
      const categoryId = category.appCategoryId
      // 搜索程序化展开锁定的卡片，鼠标移出不收起（保持搜索结果可见）
      if (this.searchExpandedCards[categoryId]) return
      const existing = this.expandTimers[categoryId]
      if (existing) {
        clearTimeout(existing)
        this.expandTimers[categoryId] = null
      }
      this.collapseCard(categoryId)
    },

    /**
     * 关闭（收起）单个卡片
     * @param {string} categoryId 分类ID
     */
    closeCard(categoryId) {
      this.$set(this.expandedCards, categoryId, false)
      this.$set(this.cardPages, categoryId, 0)
    },

    /**
     * 处理领域数据，保持三层结构
     * @param {Array} domainData 领域数据
     * @returns {Array} 处理后的领域数据
     */
    processDomainData(domainData) {
      if (!domainData || !Array.isArray(domainData)) {
        return []
      }

      return domainData.map((domain) => ({
        // 领域信息
        domainId: domain.domainId || domain.id,
        domainName: domain.domainName || domain.name,
        domainDesc: domain.domainDesc || domain.description,
        weight: domain.weight || 0,

        // 分类列表
        categories: (
          domain.categories ||
          domain.appCategories ||
          domain.categoryList ||
          []
        ).map((category) => ({
          appCategoryId:
            category.appCategoryId || category.categoryId || category.id,
          appCategoryName:
            category.appCategoryName || category.categoryName || category.name,
          appCategoryDesc:
            category.appCategoryDesc ||
            category.categoryDesc ||
            category.description ||
            category.desc,
          weight: category.weight || 0,
          appList:
            category.appList || category.apps || category.applications || [],
          ...category
        })),

        // 保留原始数据
        ...domain
      }))
    },

    /**
     * 将新的三层结构(领域->分类->应用)扁平化为两层结构(分类->应用)
     * @param {Array} domainData 领域数据
     * @returns {Array} 扁平化后的分类数据
     */
    flattenDomainData(domainData) {
      if (!domainData || !Array.isArray(domainData)) {
        return []
      }

      const flattenedCategories = []

      domainData.forEach((domain) => {
        // 兼容多种可能的字段名
        const categories =
          domain.categories || domain.appCategories || domain.categoryList || []

        if (categories && Array.isArray(categories)) {
          categories.forEach((category) => {
            // 保持原有的分类数据结构，添加领域信息
            flattenedCategories.push({
              // 领域信息
              domainId: domain.domainId || domain.id,
              domainName: domain.domainName || domain.name,

              // 分类信息 - 兼容多种字段名
              appCategoryId:
                category.appCategoryId || category.categoryId || category.id,
              appCategoryName:
                category.appCategoryName ||
                category.categoryName ||
                category.name,
              appCategoryDesc:
                category.appCategoryDesc ||
                category.categoryDesc ||
                category.description ||
                category.desc,
              weight: category.weight || 0,

              // 应用列表 - 兼容多种字段名
              appList:
                category.appList ||
                category.apps ||
                category.applications ||
                [],

              // 保留原始数据
              ...category
            })
          })
        }
      })

      return flattenedCategories
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'index-sider';

// 遮罩层
.index-sider-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(228, 225, 234, 0.8); // 改为11%透明度
  backdrop-filter: blur(5px); // 模糊度调整为15px
  -webkit-backdrop-filter: blur(5px);
  filter: grayscale(0) !important;
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  .#{$class-prefix} {
    &_modal {
      width: 1356px;
      height: 880px;
      max-width: 90%;
      max-height: 90%;
      filter: grayscale(0) !important;
      background-color: rgba(255, 255, 255, 0.3);
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      border: 1px solid rgba(255, 255, 255, 0.8);
      // 应用列表
      .app-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 14px;
      }
    }
  }

  // 列表模式：把分类标题放到应用区域内部后的样式（保留卡片框体）
  .app-category {
    padding: 8px 12px 12px;
    background: rgba(255, 255, 255, 0.2); // 半透明毛玻璃，不是纯白
    // border: 1px solid rgba(255, 255, 255, 0.2); // 边框更轻
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04); // 阴影稍微更轻
    .category-header.in-app {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 6px 4px 0; // 顶部贴近应用区，减少留白
      margin-bottom: 6px;

      .category-title {
        font-size: 16px;
        font-weight: 600;
        color: #202020;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .right-desc {
        display: inline-flex;
        align-items: center;
        margin-left: 8px;
        i {
          cursor: help;
        }
      }
    }
  }
}

// 更明显的展开/收起胶囊指示器
.expand-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px; // 原6px -> 4px
  padding: 3px 8px; // 原4px 10px -> 3px 8px
  border-radius: 999px;
  font-size: 12px; // 原13px -> 12px
  font-weight: 600;
  line-height: 1;
  color: #3153f5;
  background: rgba(74, 95, 243, 0.08); // 略微减弱底色
  border: 1px solid rgba(74, 95, 243, 0.18); // 边框更轻
  box-shadow: 0 1px 4px rgba(74, 95, 243, 0.1); // 阴影更轻
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease,
    transform 0.12s ease;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 10px; // 收起态靠右
  transform: translateY(-50%);

  i {
    font-size: 14px;
  } // 原16px -> 14px
  i.rotated {
    transform: rotate(90deg);
    transition: transform 0.2s ease;
  }

  &:hover {
    background: rgba(74, 95, 243, 0.16);
    border-color: rgba(74, 95, 243, 0.36);
    box-shadow: 0 3px 8px rgba(74, 95, 243, 0.18);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 2px 6px rgba(74, 95, 243, 0.16);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(74, 95, 243, 0.2);
  }

  &.active {
    background: #4a5ff3;
    color: #fff;
    border-color: #4a5ff3;
    box-shadow: 0 4px 10px rgba(74, 95, 243, 0.22);
  }
}

// 展开态为 close 按钮预留空间
.category-card.expanded .card-header .expand-toggle {
  right: 10px;
}

// 紧凑模式：当当前页应用数量较少时，不拉大行高与间距
.app-grid.compact {
  grid-auto-rows: auto !important; // 行高由内容自然决定
  gap: 8px !important; // 更紧凑的纵向间距
}

.app-grid.expanded.compact {
  grid-auto-rows: auto !important;
  gap: 8px !important;
}

// 卡片模式：应用项禁用容器位移/缩放，避免边缘抖动（展开与未展开均生效）
.category-card {
  .app-item {
    will-change: auto;
    // transform: translateZ(0);
    // transition: box-shadow 160ms ease;

    &:hover {
      transform: none !important; // 覆盖全局与 .category-card.expanded 内的位移/缩放
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
    }

    .app-icon img {
      transition: transform 0.25s ease;
    }

    &:hover .app-icon img {
      transform: scale(1.06);
    }
  }

  &.expanded {
    .app-item:hover {
      transform: none !important; // 再次明确覆盖展开态下原有 transform
    }
  }
}

// 列表模式（领域分组）中的应用项同样禁用容器位移/缩放，避免边缘抖动
.domain-list-container {
  .app-item {
    will-change: auto;
    transform: translateZ(0);
    transition: box-shadow 160ms ease;

    &:hover {
      transform: none !important;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
    }

    .app-icon img {
      transition: transform 0.25s ease;
    }

    &:hover .app-icon img {
      transform: scale(1.06);
    }
  }
}

// 修复“最常使用”区域边缘悬停抖动：禁用位移缩放，稳定合成层
.frequent-apps {
  padding: 20px;
  .app-item {
    will-change: auto;
    transform: translateZ(0); // 提升到GPU合成层，减少重绘
    transition: box-shadow 160ms ease; // 不在此处过渡transform

    &:hover {
      transform: none !important; // 禁止位移/缩放，避免命中区域抖动
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
    }

    .app-icon img {
      transition: transform 0.25s ease;
    }

    &:hover .app-icon img {
      transform: scale(1.06); // 仅缩放图标，不移动容器
    }
  }
}

// 收起态：减少内边距提升有效空间
.category-card:not(.expanded) .app-item {
  padding: 6px 6px; // 更紧凑，给名称留出空间
}

// 收起态：压缩标题区域高度与内边距
.category-card:not(.expanded) .card-header {
  height: 44px; // 原60px -> 44px
  padding: 10px 14px 6px; // 上下更紧凑
}

// 收起态：标题与统计字号微调
.category-card:not(.expanded) .card-title {
  font-size: 15px; // 原16px -> 15px
}

.category-card:not(.expanded) .card-title .app-count {
  font-size: 12px; // 原14px -> 12px
  color: #8b8f94;
}

// 收起态：内容顶部留白缩小
.category-card:not(.expanded) .card-content {
  padding-top: 6px;
}

// 收起态：网格在卡片内的上限与间距
.category-card:not(.expanded) .app-grid {
  gap: 16px; // 更宽松均匀的列间距
  grid-template-columns: repeat(3, 1fr); // 明确三列，宽度均匀
  grid-auto-rows: 82px; // 行高微调，适配两行名称
  max-height: 180px; // 82*2 + 16(间距) ≈ 180，容纳两排
}

// 收起态：更小的图标，便于两排展示
.category-card:not(.expanded) .app-icon {
  width: 38px;
  height: 38px;
}

// 弹窗头部
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
}
.modal-head-container {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.3); // 半透明毛玻璃，不是纯白
  // border: 1px solid rgba(255, 255, 255, 0.2); // 边框更轻
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04); // 阴影稍微更轻
  overflow: visible;
  position: relative;
  z-index: 20;
}

// 占位元素，保持标题居中
.header-spacer {
  width: 60px;
  height: 30px;
  visibility: hidden;
}

// 搜索框容器
.search-container_center {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 380px;
  margin: 0 auto;
  // 搜索输入框
  .search-input {
    width: 100%;
    height: 32px;
    border: 1px solid rgba(220, 220, 220, 0.8);
    border-radius: 4px;
    padding: 0 32px 0 12px;
    background-color: rgba(255, 255, 255, 0.9);
    outline: none;
    font-size: 14px;
    transition: all 0.3s;

    &:focus {
      border-color: #4a5ff3;
      box-shadow: 0 0 5px rgba(74, 95, 243, 0.3);
    }

    &::placeholder {
      color: #999;
    }
  }
}

// 搜索图标
.search-icon {
  position: absolute;
  right: 10px;
  color: #999;
  font-size: 16px;
  cursor: pointer;
}

// 布局切换按钮
.layout-toggle {
  display: flex;
  align-items: center;
  gap: 2px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .toggle-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #666;
    font-size: 12px;

    &:hover {
      background: rgba(74, 95, 243, 0.1);
      color: #4a5ff3;
    }

    &.active {
      background: #4a5ff3;
      color: white;
      box-shadow: 0 1px 3px rgba(74, 95, 243, 0.3);
    }
  }
}

// 搜索结果容器
.search-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 5px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  max-height: 360px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(245, 245, 245, 0.4);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(180, 180, 180, 0.5);
    border-radius: 2px;
  }
}

// 搜索结果标题
.search-results-title {
  padding: 8px 12px;
  font-size: 12px;
  color: #999;
  border-bottom: 1px solid rgba(230, 230, 230, 0.8);
}

// 搜索结果列表
.search-results-list {
  padding: 6px 0;
}

// 搜索结果项
.search-result-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: rgba(74, 95, 243, 0.08);
  }
  .result-icon {
    width: 28px;
    height: 28px;
    margin-right: 10px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 4px;
    }
  }

  .result-info {
    flex: 1;
    min-width: 0; // 允许内容收缩，避免按钮被挤掉
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .result-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 0;
  }

  .result-row-top {
    .result-name {
      font-size: 14px;
      color: #202020;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      min-width: 0;
      margin-right: 8px;
    }
    .result-add {
      flex-shrink: 0;
      background: #4a5ff3;
      border-radius: 10px;
      font-size: 12px;
      color: #ffffff;
      display: inline-block;
      height: 20px;
      padding: 2px 6px;
      line-height: 16px;
      vertical-align: middle;
    }
  }

  .result-row-bottom {
    .result-domain-cat {
      font-size: 12px;
      color: #7a8699;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 1;
      min-width: 0;
      .sep {
        margin: 0 4px;
        color: #b8bfcb;
      }
    }
    .result-owner {
      font-size: 12px;
      color: #9aa3b2;
      flex-shrink: 0;
      margin-left: 8px;
    }
  }
}

// 淡入淡出动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// 内容区域
.modal-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(245, 245, 245, 0.4);
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(180, 180, 180, 0.5);
    border-radius: 3px;
  }
}
.white-bg {
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 3%,
    rgba(255, 255, 255, 0.5) 100%
  );
  margin-bottom: 0 !important;
}
// 应用分类容器
.category-container {
  margin-bottom: 24px;
  padding: 0 2px;
  &:last-child {
    margin-bottom: 0;
  }
}
.center-line {
  height: 1px;
  border-bottom: 1px dashed #ffffff;
  box-shadow: 0 -1px 1px 0 #00000021;
  margin-bottom: 10px;
}

// 卡片容器
.category-cards-container {
  --cards-gap: 28px;
  --cards-padding-x: 20px;
  display: grid;
  grid-template-columns: repeat(4, 304px); // 固定每排显示4个卡片
  gap: var(--cards-gap); // 统一卡片间距
  padding: 0 var(--cards-padding-x); // 统一容器左右内边距
  justify-content: center;

  // 响应式设计
  @media (max-width: 1400px) {
    --cards-gap: 35px;
    --cards-padding-x: 35px;
    grid-template-columns: repeat(3, 304px); // 中等屏幕显示3个
  }

  @media (max-width: 1024px) {
    --cards-gap: 30px;
    --cards-padding-x: 30px;
    grid-template-columns: repeat(2, 304px); // 小屏幕显示2个
  }

  @media (max-width: 768px) {
    --cards-gap: 20px;
    --cards-padding-x: 20px;
    grid-template-columns: 304px; // 手机屏幕显示1个
    justify-content: center;
  }
}

// 分类卡片样式
.category-card {
  --collapsed-w: 304px;
  --expanded-w: 680px;
  width: var(--collapsed-w);
  height: 246px; // 收起态高度：两排应用 + 完整名称更充足
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  // backdrop-filter: blur(10px);
  // -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  position: relative;
  transform-origin: center; // 设置变换原点为中心
  transition: width 380ms ease, height 380ms ease, transform 380ms ease,
    box-shadow 380ms ease, opacity 380ms ease; // 精简过渡，减少抖动
  backface-visibility: hidden;
  justify-self: center; // 网格内默认居中，展开时分别对齐左右

  // &::before {
  //   content: '';
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   right: 0;
  //   height: 64px;
  //   background: linear-gradient(
  //     180deg,
  //     rgba(255, 255, 255, 0.55) 0%,
  //     rgba(255, 255, 255, 0) 100%
  //   );
  //   pointer-events: none;
  //   opacity: 0.55;
  //   transition: opacity 380ms ease;
  // }

  // 使用expandedCards状态而不是hover伪类
  &.expanded {
    width: var(--expanded-w);
    min-height: 480px;
    height: auto;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 18px 48px rgba(15, 23, 42, 0.14);
    border-radius: 8px;
    opacity: 1;
    // transform: translateY(-6px) translateX(0) scale(1); // 默认向右侧展开（左半区）
    // transform-origin: left center;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-color: rgba(255, 255, 255, 0.6);
    z-index: 10;
    overflow: visible;

    &::before {
      opacity: 0.9;
    }

    // 第3、4列固定向左展开，避免两侧同时扩展
    &:nth-child(4n),
    &:nth-child(4n - 1) {
      transform: translateY(-6px) translateX(0) scale(1); // 右半区取消左移，避免命中区域位移
      transform-origin: right center;
      justify-self: end; // 右对齐，视觉向左扩展
    }

    // 第1、2列固定向右展开
    &:nth-child(4n + 1),
    &:nth-child(4n - 2) {
      transform: translateY(-6px) translateX(0) scale(1); // 左半区不偏移
      transform-origin: left center;
      justify-self: start; // 左对齐，视觉向右扩展
    }

    .card-content {
      height: auto; // 展开态高度自适应
      min-height: calc(480px - 60px);
      padding-top: 16px; // 收紧顶部留白，给内容更多空间
      .app-grid {
        &.expanded {
          grid-template-columns: repeat(5, 1fr); // 5列布局
          grid-auto-rows: minmax(88px, auto); // 提高单行高度，保证两行名称完整
          margin: 0 8px; // 收紧左右留白
          gap: 10px; // 网格更紧凑
          max-height: none; // 不限制，让内容全部展示
        }
      }
    }
  }
}

// 卡片标题
.card-header {
  padding: 14px 18px 10px;
  text-align: center;
  background: transparent;
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; // 防止被内容覆盖
  z-index: 2; // 始终在应用内容之上
  cursor: pointer;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;

  .app-count {
    font-size: 14px;
    font-weight: 400;
    color: rgba(31, 41, 55, 0.55);
  }
}

// 展开指示箭头
.expand-indicator {
  margin-left: 6px;
  transition: transform 0.25s ease;
  color: #7f8c8d;
  font-size: 14px;

  &.rotated {
    transform: rotate(180deg);
    color: #4a5ff3;
  }
}

// 关闭按钮（仅展开时显示）
.close-card-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #666;
  background: transparent;
  transition: all 0.2s ease;

  i {
    font-size: 14px;
  }

  &:hover {
    background: rgba(74, 95, 243, 0.1);
    color: #4a5ff3;
  }
}

// 领域容器样式
.domain-container {
  padding: 0 12px;
}

.domain-list-container {
  padding: 0 12px;
}

.domain-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

// 领域标题样式 - 左对齐一排展示
.domain-header {
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
}

.domain-title {
  height: 18px;
  font-family: PingFangSC-Semibold, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #005ddd;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 0;
  padding: 0;

  i {
    display: none; // 隐藏图标，保持简洁
  }

  .domain-count {
    display: none; // 隐藏统计信息，保持简洁
  }
}

// 领域标签样式（保留用于搜索结果等场景）
.domain-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 12px;
  margin-right: 8px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
  }
}

// 卡片内容区域
.card-content {
  --content-padding: 16px 20px 20px; // 展开态默认内边距
  --content-padding-collapsed: 12px 16px 12px; // 收起态内边距
  position: relative;
  padding: var(--content-padding);
  overflow: visible; // 允许箭头显示在卡片边界外
  border-radius: 0 0 8px 8px;
  // transition: all 0.48s cubic-bezier(0.4, 0, 0.2, 1);
  height: calc(246px - 60px); // 收起态高度对应内容区高度
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  // 响应式调整内边距
  @media (max-width: 480px) {
    padding: 12px 16px 16px;
  }

  @media (max-width: 768px) {
    padding: 14px 18px 18px;
  }

  @media (min-width: 1200px) {
    padding: 18px 24px 24px;
  }
}

// 收起态：缩小内边距以容纳两排
.category-card:not(.expanded) .card-content {
  padding: var(--content-padding-collapsed);
  justify-content: center;
  align-items: center;
}

// 导航箭头
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  z-index: 10;
  font-size: 12px;
  color: rgba(31, 41, 55, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  &:hover {
    background: rgba(255, 255, 255, 0.92);
    color: rgba(31, 41, 55, 0.82);
    border-color: rgba(255, 255, 255, 0.9);
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 18px 36px rgba(15, 23, 42, 0.16);
  }

  &.nav-arrow-left {
    left: 4px;
  }

  &.nav-arrow-right {
    right: 4px;
  }

  // 卡片展开时的箭头位置调整
  .category-card.expanded & {
    &.nav-arrow-left {
      left: 8px; // 展开时稍微向内移动
    }

    &.nav-arrow-right {
      right: 8px; // 展开时稍微向内移动
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
    font-size: 10px;

    &.nav-arrow-left {
      left: 2px;
    }

    &.nav-arrow-right {
      right: 2px;
    }
  }

  @media (min-width: 1200px) {
    &.nav-arrow-left {
      left: 8px;
    }

    &.nav-arrow-right {
      right: 8px;
    }
  }
}

// 应用网格
.app-grid {
  --grid-mx-collapsed: 28px; // 收起态左右外边距
  --grid-mx-expanded: 24px; // 展开态左右外边距（统一）
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(78px, auto); // 收起态单行高度提升，保证第二排名称完整
  gap: 12px; // 统一网格间距
  justify-items: center;
  align-items: start;
  align-content: start;
  flex: 1;
  transition: transform 320ms ease, opacity 320ms ease; // 精简过渡，减少抖动
  margin: 0 var(--grid-mx-collapsed); // 统一变量
  max-height: 168px; // 2 * 78 + 12(或10) = 168，确保两排完整

  // 展开状态：显示更多列和行
  &.expanded {
    grid-template-columns: repeat(5, 1fr); // 5列布局
    grid-auto-rows: minmax(75px, auto); // 稍微压缩行高
    margin: 0 var(--grid-mx-expanded); // 统一变量
    gap: 12px; // 统一网格间距
    max-height: none; overflow-y: auto;
  }

  // 响应式设计
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: minmax(75px, auto);
    // 仅调整变量，避免与统一规则冲突
    --grid-mx-collapsed: 20px;
    --grid-mx-expanded: 24px;

    &.expanded {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: minmax(80px, auto);
      margin: 0 var(--grid-mx-expanded);
      gap: 12px;
    }
  }

  @media (max-width: 768px) {
    grid-auto-rows: minmax(78px, auto);
    --grid-mx-collapsed: 24px;
    --grid-mx-expanded: 28px;

    &.expanded {
      grid-auto-rows: minmax(82px, auto);
      // 使用统一 gap 和变量化的 margin
    }
  }

  @media (min-width: 1200px) {
    grid-auto-rows: minmax(85px, auto);
    --grid-mx-collapsed: 30px;
    --grid-mx-expanded: 36px;

    &.expanded {
      grid-auto-rows: minmax(90px, auto);
      // 使用统一 gap 和变量化的 margin
    }
  }
}
// 应用分类
.app-category {
  background-color: rgba(250, 250, 250, 0.45);
  // border-radius: 10px;
  padding: 16px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02);
}

// 分类标题
.category-header {
  margin-bottom: 8px;
}

.category-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0;
  position: relative;
  padding-left: 12px;
  display: flex;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background: linear-gradient(135deg, #4a5ff3, #4e86ff);
    border-radius: 2px;
  }
  .category-desc_dropdown_container::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    // box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: -8px;
    left: 8px;
    transform: translateX(0);
  }

  .right-desc {
    position: relative;
    display: block;
    width: 300px;
  }
  // 下拉菜单
  .category-desc_dropdown {
    font-size: 12px;
    color: #333333;
    line-height: 20px;
    position: absolute;
    left: -8px;
    top: 18px;
    padding-top: 8px;

    &_container {
      position: relative;
      padding: 20px;
      /* 根据需要调整 */
      left: auto;
      z-index: 1000;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px 8px 8px 8px;
      width: auto;
      word-wrap: break-word; /* 允许长单词或 URL 地址换行到下一行 */
      white-space: normal; /* 允许多行文本 */
      max-width: 300px;
      display: block;
    }

    // 菜单信息项
    &__item {
      padding: 10px 12px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #1e2226;
      line-height: 20px;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 6px;
      }

      &.active,
      &:hover {
        color: #4a5ff3;
        background-color: #edf1fb;
        font-weight: 600;
      }
    }
  }
}

// 应用项
.app-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease; // 精简过渡
  padding: 10px 8px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  background: transparent; // 去掉背景
  border: none; // 去掉边框

  &:hover {
    transform: translateY(-4px) scale(1.03);
    background: transparent; // 去掉背景
    box-shadow: 0 8px 18px rgba(74, 95, 243, 0.14);
    border: none; // 去掉边框

    .app-name-new {
      color: #4a5ff3;
      font-weight: 600;
    }

    .app-icon img {
      transform: scale(1.1);
      transition: transform 0.4s ease;
    }
  }

  // 在卡片布局中的特殊样式
  .category-card & {
    background: transparent; // 去掉背景
    border: none; // 去掉边框

    &:hover {
      background: transparent; // 去掉背景
      border: none; // 去掉边框
    }
  }

  // 在卡片hover状态下的样式
  .category-card.expanded & {
    background: transparent; // 去掉背景

    &:hover {
      background: transparent; // 去掉背景
      transform: translateY(-6px) scale(1.06);
      box-shadow: 0 8px 20px rgba(74, 95, 243, 0.22);
    }
  }

  // 响应式设计
  @media (max-width: 480px) {
    padding: 6px 5px;
    border-radius: 8px;

    &:hover {
      transform: translateY(-4px) scale(1.03);
    }

    .category-card.expanded &:hover {
      transform: translateY(-6px) scale(1.05);
    }
  }

  @media (max-width: 768px) {
    padding: 8px 6px;
    border-radius: 9px;

    &:hover {
      transform: translateY(-5px) scale(1.04);
    }

    .category-card.expanded &:hover {
      transform: translateY(-7px) scale(1.06);
    }
  }

  @media (min-width: 1200px) {
    padding: 12px 9px;
    border-radius: 8px;

    &:hover {
      transform: translateY(-8px) scale(1.06);
    }

    .category-card.expanded &:hover {
      transform: translateY(-10px) scale(1.1);
    }
  }
}
.app-add {
  z-index: 1000;
  position: absolute;
  top: 0;
  right: 0;
  background: #4a5ff3;
  border-radius: 10px;
  font-size: 12px;
  color: #ffffff;
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  line-height: 20px;
  padding: 0px 6px;
  & > span {
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    // line-height: 16px;
    margin-right: 2px;
  }
}
.app-auth {
  position: absolute;
  top: calc(50% - 10px) !important;
  left: 50% !important;
  background: #4a5ff3 !important;
  transform: translate(-50%, -50%) !important;
  border-radius: 10px;
  font-size: 12px;
  color: #ffffff;
  line-height: 16px;
  padding: 2px 7px;
  z-index: 1000;
  white-space: nowrap;
  filter: grayscale(0) !important;
  opacity: 1 !important;
}
.app-cancel {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 18px;
  color: #cccccc;
}
// 应用图标
.app-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  // NEW 角标样式
  .new-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background: #ff4d4f;
    color: #fff;
    font-size: 10px;
    line-height: 1;
    padding: 2px 4px;
    border-radius: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transform: translate(0, 0);
    pointer-events: none;
    font-weight: 700;
    letter-spacing: 0.2px;
  }

  // 在卡片中的特殊样式
  .category-card & {
    img {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
    }
  }

  // 响应式设计
  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    margin-bottom: 6px;

    img {
      border-radius: 8px;
    }

    .category-card & {
      img {
        border-radius: 10px;
      }
    }
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    margin-bottom: 7px;

    img {
      border-radius: 9px;
    }

    .category-card & {
      img {
        border-radius: 11px;
      }
    }
  }

  @media (min-width: 1200px) {
    width: 52px;
    height: 52px;
    // margin-bottom: 10px;

    img {
      border-radius: 8px;
    }

    .category-card & {
      img {
        border-radius: 8px;
      }
    }
  }
}

// 应用名称
.app-name {
  font-size: 14px;
  color: #333;
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.3s ease;
  font-weight: 500;
}

// 新的应用名称样式（适配卡片布局）
.app-name-new {
  color: rgba(31, 41, 55, 0.76);
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // transition: all 0.3s ease;
  font-weight: 500;
  line-height: 1.2;
  // margin-top: 4px;
  font-size: 14px;

  // 在卡片中的特殊样式
  .category-card & {
    font-size: 14px;
    color: #34495e;
    font-weight: 500;
  }
}

// 收起态：默认单行，超过 5 个字时才允许两行
.category-card:not(.expanded) .app-name-new {
  width: 5em !important;
  max-width: 5em !important;
  margin: 0 auto;
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-card:not(.expanded) .app-name-new.name-wrap {
  width: 5em !important;
  max-width: 5em !important;
  margin: 0 auto;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2; // 标准属性，补充兼容
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  max-height: 2.4em;
}

// 最常使用与卡片展开：应用名称需完整展示
.frequent-apps .app-name-new,
.category-card.expanded .app-name-new {
  white-space: normal !important;
  display: block !important;
  overflow: visible !important;
  text-overflow: initial !important;
  line-clamp: unset !important; // 标准属性，补充兼容
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  word-break: break-word;
  overflow-wrap: anywhere;
}

// 列表布局容器
.category-list-container {
  padding: 0 20px;

  // 应用列表的网格布局
  .app-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    transition: all 0.3s ease;
  }

  // 列表模式下增强分类层级感
  .category-container {
    position: relative;
    margin: 10px 0 16px;
    padding-left: 14px; // 为左侧引导线与小三角留出空间

    // // 左侧引导线
    // &::before {
    //   content: '';
    //   position: absolute;
    //   left: 6px;
    //   top: 6px;
    //   bottom: 6px;
    //   width: 2px;
    //   background: rgba(74, 95, 243, 0.12);
    //   border-radius: 2px;
    // }

    // 分类标题（列表内的副标题风格）
    .category-header.in-app {
      margin: 0 0 8px 0;
      padding: 0;

      .category-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #4a5568; // 稍淡，弱化于领域标题
        font-weight: 600;

        .category-bullet {
          margin-right: 6px;
          color: #4a5ff3;
          font-size: 14px;
          transform: translateY(1px);
        }

        .right-desc {
          margin-left: 8px;
          i {
            cursor: help;
          }
        }
      }
    }

    // 分类内应用列表与标题的分隔
    .app-list {
      padding-top: 6px;
      border-top: 1px dashed rgba(0, 0, 0, 0.06);
      margin-top: 2px;
      gap: 12px; // 列表模式略紧凑
    }
  }

  // 在列表模式下的应用项样式
  .app-item {
    &:hover {
      transform: translateY(-4px);
      background-color: rgba(255, 255, 255, 0.7);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04);
      border-color: transparent;

      .app-name-new {
        color: #4a5ff3;
        font-weight: 600;
      }

      .app-icon img {
        transform: scale(1.1);
      }
    }
  }
}

// 弹出动画（模拟Mac风格）
.zoom-in {
  animation: zoomIn 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

// 收起动画
.zoom-out {
  animation: zoomOut 0.35s cubic-bezier(0.55, 0.085, 0.68, 0.53) forwards;
}

// 定义弹出动画（模拟Mac应用弹出效果）
@keyframes zoomIn {
  0% {
    transform: scale(0.7);
    opacity: 0;
  }

  60% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

// 定义收起动画
@keyframes zoomOut {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  60% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(0.7);
    opacity: 0;
  }
}
// 从右侧滑出的动画
.slide-enter-active {
  animation: slideInRight 0.3s ease forwards;
}

@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

// 往右侧消失的动画
.slide-leave-active {
  animation: hideToRight 0.3s ease forwards;
}
/* 关键样式 */
.single-line-ellipsis {
  text-align: center;
  /* 文本溢出时显示省略号 */
  text-overflow: ellipsis;
  /* 禁止文本换行，让文本在一行显示 */
  white-space: nowrap;
  /* 超出容器部分隐藏，需配合该属性 */
  overflow: hidden;
  /* 可根据需求设置容器宽度，也可由父元素限制 */
  width: 100%;
  // border: 1px solid #ccc; /* 仅用于可视化容器范围，可删除 */
}

@keyframes hideToRight {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}

// ========== 搜索高亮：完全复刻各场景的 .app-item:hover 效果 ==========

// 列表模式（.category-list-container 下的 .app-item:hover）
.domain-list-container .category-list-container .app-item.search-highlight {
  transform: translateY(-4px) !important;
  background-color: rgba(255, 255, 255, 0.7) !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04) !important;
  border-color: transparent !important;
  .app-name-new {
    color: #4a5ff3;
    font-weight: 600;
  }
  .app-icon img {
    transform: scale(1.1);
  }
}

// 卡片模式（收起态）：对齐 .category-card .app-item:hover
.category-card:not(.expanded) .app-item.search-highlight {
  transform: none !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06) !important;
  .app-icon img {
    transform: scale(1.06);
  }
}

// 卡片模式（展开态）：对齐实际展开态 hover 效果
// 注：展开态 transform 被 1822 行的 !important 覆盖为 none
.category-card.expanded .app-item.search-highlight {
  transform: none !important;
  box-shadow: 0 8px 20px rgba(74, 95, 243, 0.22) !important;
  .app-icon img {
    transform: scale(1.06);
  }
}

// "最常使用"区域：对齐 .frequent-apps .app-item:hover
.frequent-apps .app-item.search-highlight {
  transform: none !important;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06) !important;
  .app-icon img {
    transform: scale(1.06);
  }
}
</style>
